import { Field } from 'formik';
import styled from 'styled-components';

import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';

type PageTitleFieldTint = 'light' | 'dark';

export default styled(Field)<{ tint: PageTitleFieldTint }>`
	width: 100%;
	display: block;
	overflow: hidden;
	font-size: 22px;
	line-height: 1.25;
	font-weight: 700;
	margin: 0;
	padding: 0;
	color: ${(props) => props.theme.colors.antracite};
	background-color: transparent;

	${(props) =>
		props.tint === 'light' &&
		`
		color: ${props.theme.colors.white};
		::placeholder {
			color: rgba(${toRgbString(props.theme.colors.white)}, 0.6);
		}
	`}

	:disabled {
		background-color: transparent;
	}
`;
